<template>
    <div>
        <viewer v-if="isKonfirmasi" :value="form" is-konfirmasi @koreksi="koreksi" @ok="save"></viewer>
        <b-card v-show="!isKonfirmasi" v-if="form" class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isEdit ? 'Edit' : 'Buat' }} Inventaris Barang</h5>
            </b-card-header>
            <b-card-body>
                <div class="form-group">
                    <label>Nama Barang</label>
                    <input v-validate="'required'" v-model="form.name" type="text" name="nama" class="form-control">
                    <span class="text-danger">{{ errors.first('nama') }}</span>
                </div>

                <div class="form-group">
                    <label class="form-control-label">Tanggal Pembelian</label>
                    <div class="input-group mb-0 d-flex">
                        <date-picker class="w-auto flex-grow-1" v-model="form.tanggal_pembelian" v-validate="'required'" type="date" name="tanggal_pembelian" placeholder="Tanggal Berangkat" :editable="true" format="DD-MM-YYYY"></date-picker>
                    </div>
                    <span class="text-danger">{{ errors.first('tanggal_pembelian') }}</span>
                </div>

                <div class="form-group">
                    <label>Jumlah</label>
                    <input v-validate="'required|min_value:0'" min="0" v-model="form.jumlah" @input="updateTotal" type="number" name="jumlah" class="form-control">
                    <span class="text-danger">{{ errors.first('jumlah') }}</span>
                </div>

                <div class="form-group">
                    <label>Harga</label>
                    <input v-validate="'required|min_value:0'" min="0" v-model="form.harga" @input="updateTotal" type="number" name="harga" class="form-control">
                    <span class="text-danger">{{ errors.first('harga') }}</span>
                </div>

                <div class="form-group">
                    <label>Total</label>
                    <input v-validate="'required|min_value:0'" min="0" v-model="form.total" @input="updateHarga" type="number" name="total" class="form-control">
                    <span class="text-danger">{{ errors.first('total') }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                <button :disabled="isLoading" @click="konfirmasi(isEdit)" type="button" class="btn btn-primary mr-2">Simpan</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import Viewer from './Viewer';

export default {
    name: "inventaris-barang-form",

    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        DatePicker,
        Viewer,
    },

    data() {
        return {
            form: null,
            isKonfirmasi: false,
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        if (this.value) {
            this.initForm();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.form = Object.assign({}, this.value);
        }
    },

    methods: {
        resetForm() {
            this.form = Object.assign({}, {
                name: null,
                tanggal_pembelian: null,
                jumlah: null,
                harga: null,
                total: null,
            });
        },

        initForm() {
            let self = this;

            self.form = Object.assign({}, self.value);
            if (self.form.tanggal_pembelian) {
                self.form.tanggal_pembelian = new Date(self.formatDate(self.form.tanggal_pembelian, 'YYYY-MM-DD'));
            }
        },

        konfirmasi(isSave = false) {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    if (isSave) {
                        self.save();
                    } else {
                        self.form.barangs = Object.assign([], self.barangs);
                        self.isKonfirmasi = true;
                    }
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;

            let data = {
                name: self.form.name,
                tanggal_pembelian: self.convertUserTimezone(self.form.tanggal_pembelian),
                jumlah: self.form.jumlah,
                harga: self.form.harga,
                total: self.form.total,
            }

            let api = self.isEdit ? '/api/inventaris-barangs/'+self.form.id : '/api/inventaris-barangs';

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                self.isLoading = false;
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        updateTotal() {
            this.form.total = (this.form.jumlah || 0) * (this.form.harga || 0);
        },

        updateHarga() {
            this.form.harga = (this.form.total || 0) / (this.form.jumlah || 0);
        },
    },
}
</script>
